<template>
  <v-container style="padding-top: 4%">
    <v-card :elevation="0" style="padding-bottom: 5%">
      <v-row justify="center">
        <v-col md="5">
          <v-card-title class="text-h5 body">{{
            content[0].name
          }}</v-card-title>
          <v-card-subtitle class="text-left body">{{
            content[0].subtitle
          }}</v-card-subtitle>
          <v-card-text class="text-left body">
            {{ content[0].body }}
            <v-list-item style="padding: 0px" two-line>
              <v-list-item-content>
                <v-list-item-subtitle>
                  {{ content[0].studies[0] }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  {{ content[0].studies[1] }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
        </v-col>
        <v-col md="2">
          <v-avatar size="180" tile>
            <v-img :src="require('../assets/e-fuchs.jpg')"></v-img>
          </v-avatar>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      content: [
        {
          name: "EDGARDO FUCHS",
          subtitle: "Socio Gerente",
          body: "Ingeniero con 37 años de experiencia en el mercado de energía eléctrica, en empresas generadoras y de consultoría.",
          studies: [
            "Ingeniero Civil Industrial. Universidad de Chile",
            "MBA. ILADES – Loyola College in Maryland",
          ],
        },
      ],
    };
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.body {
  color: #161c2d;
}
</style>



// WEBPACK FOOTER //
// src/components/Who.vue